import React from 'react';
import { AlertCircle, X } from 'lucide-react';
import Modal from '../../../shared/components/ui/Modal';

export default function SubmissionErrorBanner({ containerRef, message, modalOpen, onOpenModal, onCloseModal, onDismiss }: {
  containerRef?: React.Ref<HTMLDivElement>;
  message: string;
  modalOpen: boolean;
  onOpenModal: () => void;
  onCloseModal: () => void;
  onDismiss: () => void;
}) {
  return (
        <>
          <div
            ref={containerRef}
            className="mb-5 scroll-mt-32 flex items-center justify-between gap-3 rounded-lg border border-red-200 bg-red-50 px-3 py-2.5 text-[11px] text-red-700"
            role="alert"
          >
            <div className="flex min-w-0 items-center gap-2">
              <AlertCircle className="h-4 w-4 shrink-0 text-red-500" />
              <strong className="font-semibold">Submission failed</strong>
              <button
                type="button"
                onClick={() => onOpenModal()}
                className="shrink-0 text-red-500 hover:text-red-700"
              >
                Detailed Error
              </button>
            </div>
            <button
              type="button"
              onClick={() => onDismiss()}
              className="shrink-0 text-red-500 hover:text-red-700"
              title="Dismiss"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
          <Modal
            isOpen={modalOpen}
            onClose={() => onCloseModal()}
            title="Submission failed"
            size="lg"
          >
            <p className="whitespace-pre-line break-words text-sm text-red-700">
              {message}
            </p>
          </Modal>
        </>
  );
}
